/**
 * App-store destination for the OSA funnel's terminal "Download RISE"
 * screen (shown after the sold-out modal). We detect the device and send
 * Android users to the Play Store; everyone else (iOS + desktop) goes to
 * the App Store, per product.
 */

/** RISE iOS App Store listing (already used by the insomnia intake's
 *  RiseAppHandoffInterstitial). */
export const RISE_IOS_APP_URL = 'https://apps.apple.com/us/app/rise-sleep-tracker/id1453884781';

/** RISE Google Play listing (package com.risesci.nyx). */
export const RISE_ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.risesci.nyx';

/** True when the current device's user agent looks like Android. */
export const isAndroid = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  return /android/i.test(navigator.userAgent);
};

/**
 * The store URL to send the user to from the Download RISE screen.
 * Android → Play Store; everything else (iOS, desktop) → App Store.
 */
export const getRiseAppDownloadUrl = (): string => (isAndroid() ? RISE_ANDROID_APP_URL : RISE_IOS_APP_URL);
